var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-viewer-tag"},[(!!_vm.icon)?_c('pendo-icon',{attrs:{"size":"12","stroke":"#2a2c35","type":_vm.icon}}):_vm._e(),_c('p',{staticClass:"query-viewer-tag--label"},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }